import React from 'react';

import { Container } from './styles'

import Valor from '../../assets/Valor.png'

function Valores() {
  return (
    <Container>
      <div>
        <h1>OS VALORES</h1>
        <br/>
        <p>A 2º edição da AGOPREV e a 4ºedição da ExpoPrev, será o encontro de Gestores, Conselheiros e Servidores Públicos
          abordando temas atuais e fatos relevantes na área de RPPS. O espaço ideal para adquirir conhecimentos sobre os 
          diversos temas que cercam os RPPS e interagir com Gestores de vários RPPS e os Especialistas mais renomados do Brasil.
        </p>
        <br/>
        <p>Em caso de dúvidas, basta entrar em contato pelo (62) 99609-0413 ou enviar para contato@expoprev.com.br. 
        </p>
        <br/>
        <img src={Valor} alt='Valores'/>
        <br/>
        <br/>
        <h3>
        A Secretaria de Previdência fará atendimento presencial no decorrer de todo o evento sobre DAIR, DIPR, GESCON, SIG, DRAA, DPIN, Certificação Profissional, Pró-Gestão.
        </h3>
      </div>
    </Container>
  );
}

export default Valores;